// extracted by mini-css-extract-plugin
export var active = "_8w-a";
export var activeIndicator = "_8w-9";
export var disabled = "_8w-b";
export var fullWidth = "_8w-2";
export var lg = "_8w-7";
export var md = "_8w-6";
export var redoButtonTabGroup = "_8w-0";
export var sm = "_8w-5";
export var tabButton = "_8w-4";
export var tabButtonsContainer = "_8w-1";
export var themeDestructive = "_8w-d";
export var themeNormal = "_8w-c";
export var themeSuccess = "_8w-e";
export var xl = "_8w-8";
export var xs = "_8w-3";